import DelegationPage from "./DelegationPage";
import SearchDelegationPage from "./SearchDelegationPage";

export { DelegationPage, SearchDelegationPage };



// WEBPACK FOOTER //
// ./components/employee/delegation/index.js